var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCausasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.709,
    height: 31.287,
    viewBox: "0 0 20.709 31.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7827ee;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.557 -0.336)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.557 0.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.051,31.147a.892.892,0,0,0,1.2-.4,9.666,9.666,0,0,1,3.81-4.031,9.844,9.844,0,0,0,2.285.911.9.9,0,0,0,.225.029A.892.892,0,0,0,23.79,25.9a8.049,8.049,0,0,1-.677-15.371c.658.553,1.382,1.114,2.2,1.7a1.007,1.007,0,0,0,1.233-.026c.77-.548,1.47-1.087,2.115-1.626A8.05,8.05,0,0,1,30.143,24.9l-.032.021a8.041,8.041,0,0,1-1.021.546.892.892,0,0,0,.725,1.63c.262-.116.514-.247.762-.384A9.627,9.627,0,0,1,34.559,31.1a.893.893,0,0,0,.815.527.881.881,0,0,0,.366-.079.892.892,0,0,0,.447-1.179,11.424,11.424,0,0,0-4.011-4.753A9.835,9.835,0,0,0,30.112,9.255c.114-.111.235-.221.344-.333A10.551,10.551,0,0,0,32.3,6.529a3.565,3.565,0,0,0,.491-1.764A4.57,4.57,0,0,0,31.077,1.2a3.8,3.8,0,0,0-2.421-.86,3.862,3.862,0,0,0-2.732,1.126l-.011.01A3.826,3.826,0,0,0,22.514.4a4,4,0,0,0-2.752,1.922A3.985,3.985,0,0,0,19.555,6.6a10.382,10.382,0,0,0,1.516,2.013c.186.2.381.394.58.59a9.829,9.829,0,0,0-2.183,16.408,11.471,11.471,0,0,0-3.817,4.34A.893.893,0,0,0,16.051,31.147ZM21.109,5.72a2.235,2.235,0,0,1,.176-2.473,2.2,2.2,0,0,1,1.547-1.1,2.119,2.119,0,0,1,.375-.034,2.042,2.042,0,0,1,1.819,1.136l.1.188a.892.892,0,0,0,.788.475h.014a.891.891,0,0,0,.787-.5,2.6,2.6,0,0,1,.479-.7,2.138,2.138,0,0,1,2.748-.145,2.818,2.818,0,0,1,1.069,2.231,1.834,1.834,0,0,1-.283.885,8.754,8.754,0,0,1-1.541,1.98c-.36.367-2.611,2.3-3.272,2.786a25.461,25.461,0,0,1-3.542-3.07A8.539,8.539,0,0,1,21.109,5.72Z",
    transform: "translate(-15.557 -0.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.729,63.1a4.878,4.878,0,0,0,2.889.953,4.72,4.72,0,0,0,2.79-.929.892.892,0,0,0-1.04-1.45,2.956,2.956,0,0,1-3.541.02.892.892,0,0,0-1.1,1.406Z",
    transform: "translate(-31.13 -40.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.582,50.922a1.049,1.049,0,1,0-1.049,1.049A1.05,1.05,0,0,0,40.582,50.922Z",
    transform: "translate(-30.539 -32.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.78,50.922a1.048,1.048,0,1,0-1.048,1.049A1.049,1.049,0,0,0,54.78,50.922Z",
    transform: "translate(-39.818 -32.707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCausasLogo);
export default __webpack_public_path__ + "static/media/Causas_logo.b02a239049246f2c781d51d29747a6c4.svg";
export { ForwardRef as ReactComponent };